var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 10,
  viewBox: "0 0 8 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.14644 4.35355L3.99999 1.20711L0.853545 4.35355L0.146439 3.64645L3.64644 0.146447C3.8417 -0.0488155 4.15828 -0.0488155 4.35355 0.146447L7.85355 3.64645L7.14644 4.35355Z",
  fill: "#767676"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.853561 5.64645L4.00001 8.79289L7.14645 5.64645L7.85356 6.35355L4.35356 9.85355C4.1583 10.0488 3.84172 10.0488 3.64645 9.85355L0.146454 6.35355L0.853561 5.64645Z",
  fill: "#767676"
})));
export { SvgReorder as ReactComponent };
export default __webpack_public_path__ + "assets/ff2151b9.svg";